import { render, staticRenderFns } from "./batch_transfer_dialog.vue?vue&type=template&id=6bc27e78"
import script from "./batch_transfer_dialog.vue?vue&type=script&lang=js"
export * from "./batch_transfer_dialog.vue?vue&type=script&lang=js"
import style0 from "./batch_transfer_dialog.vue?vue&type=style&index=0&id=6bc27e78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports